import { Grid, Flex, Spinner } from "@chakra-ui/react"
import LifeIMC from "./LifeIMC"
import Risk from "./Risk"
import Indicators from "./Indicators"
import BirthDetails from "./BirthDetails"
import { Life } from "interfaces/life"

interface Props {
    life: Life
    isLoading: boolean
}

const Charts = ({ life, isLoading }: Props) => {

    if(isLoading)
        return (
            <Flex w="full" justifyContent="center" py={4}>
                <Spinner size="lg" />
            </Flex>
        )

    return (
        <> 
            <BirthDetails life={life} />
            <Grid
                w="full"
                templateColumns="repeat(1, 1fr)"
                templateRows="repeat(1, 1fr)"
                gap="16px"
                mb="16px"
            >
                <LifeIMC />
                {/* <Risk /> */}
            </Grid>
            <Indicators />
        </>
    )
}

export default Charts